import React from "react";
import { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, joinAuction, actmore } from "../../actions/index";
import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { FirebaseContext } from '../../FirebaseContext';
import styled from 'styled-components';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #f3f4f6;
  padding: 2rem;
`;

const FormContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const StyledTabs = styled(Tabs)`
  background: #f8fafc;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05);
  padding: 2rem;

  .react-tabs__tab-list {
    border-bottom: 2px solid #eef2f7;
    margin-bottom: 2rem;
  }

  .react-tabs__tab {
    padding: 1rem 2rem;
    font-weight: 500;
    color: #64748b;
    
    &--selected {
      color: #3b82f6;
      border-color: #3b82f6;
    }
  }
`;

const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FieldCard = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  transition: all 0.2s ease;
  height: fit-content;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    // transform: translateY(-3px);
    border-color: #d1d5db;
  }

  /* Add subtle highlight on the top border */
  border: 1px solid #3b82f6;
  .field-actions{
    display: flex;
    align-items: center;
  }
`;

const FieldHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 1rem;

  .field-inputs {
    display: flex;
    gap: 1rem;
    flex: 1;
  }
`;

const FieldLabel = styled.div`
  font-weight: 500;
  color: #1e293b;
  font-size: 1.4rem;
`;

const ControlsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 1rem;

  .checkbox-container {
    grid-column: 1 / -1;
    margin-top: 0.5rem;
  }
`;

const CustomFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
`;

const ActionButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  &.primary {
    background: #3b82f6;
    color: white;
    border: none;
    
    &:hover {
      background: #2563eb;
    }
  }

  &.secondary {
    background: white;
    color: #64748b;
    border: 1px solid #e2e8f0;
    
    &:hover {
      background: #f8fafc;
    }
  }
`;

const FormField = ({ label, field, onChange }) => (
    <FieldCard>
        <FieldHeader>
            <FieldLabel>{label}</FieldLabel>
            <div className="field-actions">
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={field.s === "1"}
                        onChange={e => onChange(field.k, 's', e.target.checked ? "1" : "0")}
                    />
                    <span className="slider" />
                </label>
            </div>
        </FieldHeader>

        <ControlsGrid>
            <div className="control-group">
                <input
                    type="text"
                    value={field.l}
                    onChange={e => onChange(field.k, 'l', e.target.value)}
                    placeholder="Custom label"
                    className="label-input"
                />
            </div>
            <div className="control-group">
                <input
                    type="text"
                    value={field.p || ''}
                    onChange={e => onChange(field.k, 'p', e.target.value)}
                    placeholder="Field Placeholder"
                    className="placeholder-input"
                />
            </div>
            <div className="control-group checkbox-container">
                <label className="checkbox-label checkbox-label-new">
                    <input
                        type="checkbox"
                        checked={field.r === "1"}
                        onChange={e => onChange(field.k, 'r', e.target.checked ? "1" : "0")}
                    />
                    <span>Required</span>
                </label>
            </div>
        </ControlsGrid>
    </FieldCard>
);

const CustomField = ({ field, index, onUpdate, onDelete }) => (
    <FieldCard>
        <FieldHeader>
            <div className="field-inputs">
                <input
                    type="text"
                    value={field.l}
                    onChange={e => onUpdate(index, 'l', e.target.value)}
                    placeholder="Field Label"
                    className="custom-label-input"
                />
                <input
                    type="text"
                    value={field.p || ''}
                    onChange={e => onUpdate(index, 'p', e.target.value)}
                    placeholder="Field Placeholder"
                    className="custom-placeholder-input"
                />
            </div>
            <ActionButton className="secondary" onClick={() => onDelete(index)}>
                <i className="fas fa-trash" />
            </ActionButton>
        </FieldHeader>

        <ControlsGrid>
            <div className="control-group">
                <span>Show Field</span>
                <label className="switch">
                    <input
                        type="checkbox"
                        checked={field.s === "1"}
                        onChange={e => onUpdate(index, 's', e.target.checked ? "1" : "0")}
                    />
                    <span className="slider" />
                </label>
            </div>
            <div className="control-group">
                <span>Required</span>

                <label className="switch">
                    <input
                        type="checkbox"
                        checked={field.r === "1"}
                        onChange={e => onUpdate(index, 'r', e.target.checked ? "1" : "0")}
                    />
                    <span className="slider" />
                </label>
            </div>
        </ControlsGrid>

        <div className="field-type-selector">
            <select
                value={field.t || "0"}
                onChange={e => onUpdate(index, 't', e.target.value)}
                className="type-select"
            >
                <option value="0">Text Input</option>
                <option value="1">Number Input</option>
                <option value="2">Dropdown Options</option>
            </select>

            {field.t === "2" && (
                <ActionButton
                    className="secondary"
                    onClick={() => onUpdate(index, 'showOptions', true)}
                >
                    Configure Options
                </ActionButton>
            )}
        </div>
    </FieldCard>
);

// Add Modal styled component
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  h3 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1.4rem;
    color: #1e293b;
  }

  .modal-description {
    color: #64748b;
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }

  .options-input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
  }
`;

// Add Modal component
const Modal = ({ onClose, children }) => (
    <ModalOverlay onClick={onClose}>
        <ModalContent onClick={e => e.stopPropagation()}>
            {children}
        </ModalContent>
    </ModalOverlay>
);

function JoinauctionCode(match) {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [joindata, setjoindata] = useState([]);
    const [isActive, setActive] = useState(false);
    const getpageData = useSelector((state) => state.setactlistData);
    const loginuser = useSelector((state) => state.setUserlog);
    const { upddata } = useContext(FirebaseContext);
    const isfirsttime = useSelector((state) => state.isfirsttime);
    const getaucpageData = useSelector((state) => state.setactlistData);
    const aucmoredetail = useSelector((state) => state.actmoredata);

    const [isDisabled, setDisabled] = useState(false);
    const refresh = useSelector((state) => state.setRefresh);
    const history = useHistory({ forceRefresh: true });
    const [cid, setCid] = useState(loginuser["cid"]);
    const [customcount, setcustomcount] = useState(0);
    const [cuss, setcuss] = useState('0');
    const [cusreq, setcusreq] = useState('0');
    const [cusl, setcusl] = useState('');
    const [cuslist, setcuslist] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [isoptpopup, setisoptpopup] = useState(null);
    const [optval, setoptval] = useState("");
    const [description, setDescription] = useState('');

    const aid = localStorage.getItem("auction_id");

    const ls = ['age', 'fname', 'cat', 'detail', 'tname', 'tno', 'tshirt', 'trouser', 'icon', 'sp1', 'sp2', 'sp3', 'receipt', 'mobile'];
    const defaultLabels = {
        age: 'Age',
        mobile: 'Mobile',
        fname: "Father's Name",
        cat: 'Category',
        detail: 'Detail',
        tname: 'Jersey Name',
        tno: 'Jersey Number',
        tshirt: 'T-shirt Size',
        trouser: 'Trouser',
        icon: 'Icon',
        sp1: 'Specification 1',
        sp2: 'Specification 2',
        sp3: 'Specification 3',
        receipt: 'Receipt'
    };

    const initiallOptions = Object.fromEntries(
        ls.map((l, index) => [l, {
            s: "1",
            r: "0",
            l: defaultLabels[l] || l,
            p: '',
            k: index + 1
        }])
    );
    const [field, setfield] = useState(initiallOptions);
    const [customfield, setcustomfield] = useState([]);


    const fetchData = async () => {
        // localStorage.removeItem('auction_id')

        setActive(true);
        //  console.log("fetch cid:" + cid);
        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
            },
        };
        //  console.log(aid)
        await DataService.plrforminfo({ 'aid': aid }, hdr)
            .then((res) => {
                let response = res.data;
                 console.log("response");
                 console.log(response);


                if (response.success == true) {

                    //   let responsedata = response.data;
                    //   setData(responsedata);

                    //   dispatch(actlistData({ responsedata }));
                    setData(response.data)
                    // //  console.log(field)
                    if (response.data.cf !== "") {

                        setcuslist(response.data.cf)
                    }
                    if(response.data.info !== ""){
                        setDescription(response.data.info)
                    }
                    response.data.df.map((ele) => {
                        //  console.log("ele")
                        Object.entries(field).forEach(([key, value]) => {
                            // //  console.log(key)
                            if (ele.k == value.k) {
                                setfield(prevObjects => {
                                    return {
                                        ...prevObjects,
                                        [key]: ele
                                    };
                                })
                            }
                        });

                    })
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                setActive(false);
            });

    };

    useEffect(() => {
        fetchData()
        if (refresh == 1) {

            // fetchData(0);
        } else {
            if (getpageData == 0) {

                // fetchData(0);
            } else {
                if (getpageData.responsedata.cid == cid) {

                    // fetchData(0)
                    // setData(getpageData.responsedata);
                } else {
                    let responsedata = getpageData.responsedata;
                    responsedata.list = [];
                    // setData(responsedata);
                    // fetchData(0);
                }
            }
        }
        // if (localStorage.getItem('acode')) {
        //     var values = {
        //         'acode': localStorage.getItem('acode')
        //     }
        //     onSubmit(values);

        // }

        window.scrollTo(0, 0);
    }, [refresh]);
    const handleOptionChange = (event) => {
        if (event.target.value)
            setSelectedOption(event.target.value);
    };
    const firechange = (datasnap) => {
        if (datasnap.type == "1" && datasnap.upd == "3") {
            if (getaucpageData != 0) {
                const updateitem = getaucpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

                let responsedata = {
                    responsedata: {
                        path: getaucpageData.responsedata.path,
                        cid: cid,
                        list: updateitem,
                    },
                };
                dispatch(actlistData(responsedata));
            }
            history.push(BASE_PATH + 'my-auction')
        }
    }
    useEffect(() => {
        if (upddata !== null) {
            if (upddata !== isfirsttime) {
                firechange(upddata);
                if (upddata.upd == "4") {
                    dispatch(setisfirsttime(upddata));
                }
            }
        }
    }, [upddata]);
    function choosedauction(code) {
        var values = {
            'acode': code
        }
        onSubmit(values);
    }
    function handlechange(l, option, val) {
        setfield((prevlOptions) => ({
            ...prevlOptions,
            [l]: { ...prevlOptions[l], [option]: val },
        }));

    }
    function handlecustomchange(l, option, val) {
        setcustomfield((prevlOptions) => ({
            ...prevlOptions,
            [l]: { ...prevlOptions[l], [option]: val },
        }));
    }



    const postfield = async () => {
        setActive(true);

        var hdr = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };


        var farr = []

        ls.map((ele) => {

            farr.push(field[ele])
        })

        let exitFunction = false;
        cuslist.map((ele) => {
            if (ele.t && ele.t == '2') {
                if (ele.o == undefined) {
                    alert('Set options for ' + ele.l)
                    exitFunction = true;
                    setActive(false);
                    return
                }
            }
        })
        if (exitFunction) {
            // toast.dismiss(toastContainerId);

            return; // Exit the function
        }
        const id = toast.loading("Please wait...");
        cuslist.map((ele) => {
            if (ele.t == undefined) {
                ele.t = '0'
            }
        })
        // //  console.log('newcuslist')
        // //  console.log(newcuslist)
        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });

        var val = {}
        const jsonString = JSON.stringify(farr);
        const jsonString2 = JSON.stringify(cuslist);

        val.df_f = jsonString;
        val.custom_f = jsonString2;
        val.info = description;

         console.log(val)
        //  console.log(cuslist)
        await DataService.setplrform(val, hdr)
            .then((res) => {
                let response = res.data;
                 console.log("custom resp")
                 console.log(response)
                toast.dismiss(toastContainerId);

                if (response.success == true) {
                    if (aucmoredetail != 0) {
                        //  console.log('kkkk')
                        aucmoredetail.extra = cuslist
                        //  console.log('kkkk22')

                        dispatch(actmore(aucmoredetail))
                        //  console.log('kkkk33')

                    }
                    //  console.log("succcessss")
                    toast.success("Updated successfully", {
                        theme: "dark",
                        position: "bottom-center",
                    });

                } else {

                    if (response.msg != "")
                        toast.error(response.msg, { theme: "colored" });
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });
    };
    function updcustlbl(i, v) {
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, l: v } : ele
        );
        //  console.log(updatedList)
        setcuslist(updatedList)
    }
    function updcustreq(i, v) {
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, r: v } : ele
        );
        setcuslist(updatedList)
        //  console.log(updatedList)

    }
    function updinptype(i, v) {
        setSelectedOption(v)
        if (v == 2) {

            setisoptpopup(i)
        }
        else {
            setisoptpopup(0)

        }
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, t: v } : ele
        );
        setcuslist(updatedList)
        //  console.log(updatedList)

    }
    function updcusts(i, v) {
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, s: v } : ele
        );
        setcuslist(updatedList)
    }
    function updopt(i, v) {
        console.log('cuslist')
        console.log(cuslist);
        console.log(i);
        const updatedList = cuslist.map((ele, index) =>
            index === i ? { ...ele, o: v } : ele
        );
        setcuslist(updatedList);
        setisoptpopup(0);
    }
    function addcustomfield() {
        setcuslist((prev) => [...prev, {
            's': '1',
            'r': '0',
            'l': '',
            'p': '',
            't': '0'
        }]);
    }
    function delcustom(i) {

        const updatedList = cuslist.filter((ele, index) => index !== i)
        setcuslist(updatedList)
    }

    const handleCustomUpdate = (index, field, value) => {
        console.log("handleCustomUpdate called:", index, field, value);

        if (field === 'showOptions') {
            console.log("Setting popup for index:", index + 1);
            setisoptpopup(index + 1);
            const currentField = cuslist[index];
            setoptval(currentField.o || '');
            return;
        }

        const updatedList = cuslist.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );
        setcuslist(updatedList);
    };

    // Function to handle saving options
    const handleSaveOptions = (index) => {
        const updatedList = cuslist.map((item, i) =>
            i === (index - 1) ? { ...item, o: optval } : item
        );
        setcuslist(updatedList);
        setisoptpopup(null);
        setoptval("");
    };

    return (
        <LoadingOverlay active={isActive} spinner={<BounceLoader color="#337ab7" />}>
            <PageContainer className="customize_css">
                <FormContainer>
                    <Navigationtitle data={match} />

                    <StyledTabs>
                        <TabList>
                            <Tab>Default Fields</Tab>
                            <Tab>Custom Fields</Tab>
                            <Tab>Add Description</Tab>
                        </TabList>

                        <TabPanel>
                            <FieldsGrid>
                                {ls.map((key) => (
                                    <FormField
                                        key={key}
                                        label={defaultLabels[key]}
                                        field={field[key]}
                                        onChange={(k, option, val) => handlechange(key, option, val)}
                                    />
                                ))}
                            </FieldsGrid>
                        </TabPanel>

                        <TabPanel>
                            <FieldsGrid>
                                {cuslist.map((field, index) => (
                                    <CustomField
                                        key={index}
                                        field={field}
                                        index={index}
                                        onUpdate={handleCustomUpdate}
                                        onDelete={delcustom}
                                    />
                                ))}
                            </FieldsGrid>

                            <div className="actions-bar">
                                <ActionButton
                                    className="primary"
                                    onClick={addcustomfield}
                                >
                                    Add New Custom Field
                                </ActionButton>
                            </div>
                        </TabPanel>

                        <TabPanel>
                            <DescriptionContainer>
                                <h3>Form Description</h3>
                                <p className="description-helper">
                                    Add a description that will be displayed at the top of your form.
                                </p>
                                <StyledTextArea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Enter form description here..."
                                    rows={8}
                                />
                            </DescriptionContainer>
                        </TabPanel>
                    </StyledTabs>

                    <div className="form-actions">
                        <ActionButton
                            className="primary"
                            onClick={postfield}
                        >
                            Save All Changes
                        </ActionButton>
                    </div>
                </FormContainer>
            </PageContainer>

            {isoptpopup !== null && (
                <Modal onClose={() => setisoptpopup(null)}>
                    <h3>Configure Dropdown Options</h3>
                    <p className="modal-description">
                        Enter options separated by commas (e.g., Option1,Option2,Option3)
                    </p>
                    <input
                        type="text"
                        value={optval}
                        onChange={e => setoptval(e.target.value)}
                        placeholder="Option1,Option2,Option3"
                        className="options-input"
                    />
                    <div className="modal-actions">
                        <ActionButton
                            className="secondary"
                            onClick={() => setisoptpopup(null)}
                        >
                            Cancel
                        </ActionButton>
                        <ActionButton
                            className="primary"
                            onClick={() => handleSaveOptions(isoptpopup)}
                        >
                            Save Options
                        </ActionButton>
                    </div>
                </Modal>
            )}
        </LoadingOverlay>
    );
}

// Add additional styles
const additionalStyles = `
    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 20px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #cbd5e1;
        transition: .3s;
        border-radius: 34px;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 14px;
        width: 14px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        transition: .3s;
        border-radius: 50%;
    }

    input:checked + .slider {
        background-color: #3b82f6;
    }

    input:checked + .slider:before {
        transform: translateX(20px);
    }
    .customize_css{
        input{
            min-height:20px;
        }

    }

    .label-input,
    .placeholder-input {
        width: 100%;
        padding: 0.75rem;
        border: 1px solid #e2e8f0;
        border-radius: 4px;
        font-size: 1.3rem;
        color: #1e293b;
    }

    .label-input::placeholder,
    .placeholder-input::placeholder {
        color: #94a3b8;
        font-size: 1.3rem;
    }

    .control-group {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .checkbox-label-new {
        margin: 0 8px;
        font-size: 1.3rem;
        display:flex;
        // align-items:center;
    }

    .checkbox-label input[type="checkbox"] {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }

    .field-type-selector {
        margin-top: 0.75rem;
        display: flex;
        gap: 0.75rem;
        align-items: center;
    }

    .type-select {
        flex: 1;
    }

    .form-actions {
        margin-top: 2rem;
        text-align: center;
        position: sticky;
        bottom: 1rem;
        background: white;
        padding: 1rem;
        border-radius: 8px;
        box-shadow: 0 -4px 6px rgba(0,0,0,0.05);
    }

    .modal-actions {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    .options-input {
        width: 100%;
        padding: 0.75rem;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        font-size: 0.9rem;
    }

    .field-inputs {
        display: flex;
        gap: 1rem;
        flex: 1;
    }

    .custom-label-input,
    .custom-placeholder-input {
        width: 100%;
        padding: 0.75rem;
        border: 1px solid #e2e8f0;
        border-radius: 4px;
        font-size: 1.3rem;
        color: #1e293b;
    }

    .custom-label-input::placeholder,
    .custom-placeholder-input::placeholder {
        color: #94a3b8;
        font-size: 1.3rem;
    }

    .field-type-selector {
        margin-top: 0.75rem;
        display: flex;
        gap: 0.75rem;
        align-items: center;
    }

    .type-select {
        flex: 1;
        padding: 0.75rem;
        border: 1px solid #e2e8f0;
        border-radius: 4px;
        font-size: 1.3rem;
        color: #1e293b;
    }

    .field-inputs {
        display: flex;
        gap: 1rem;
        flex: 1;
        margin-right: 1rem;
    }

    .field-card {
        position: relative;
        overflow: hidden;
    }

    .field-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: #3b82f6;
        opacity: 0;
        transition: opacity 0.2s ease;
    }

    .field-card:hover::before {
        opacity: 1;
    }
`;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = additionalStyles;
document.head.appendChild(styleSheet);

// Add new styled components
const DescriptionContainer = styled.div`
    background: white;
    border-radius: 12px;
    padding: 2rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    h3 {
        margin: 0 0 1rem 0;
        color: #1e293b;
        font-size: 1.4rem;
        font-weight: 500;
    }

    .description-helper {
        color: #64748b;
        font-size: 1.1rem;
        margin-bottom: 1.5rem;
    }
`;

const StyledTextArea = styled.textarea`
    width: 100%;
    min-height: 200px;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1.3rem;
    line-height: 1.5;
    color: #1e293b;
    resize: vertical;
    transition: border-color 0.2s ease;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &::placeholder {
        color: #94a3b8;
    }
`;

export default JoinauctionCode;


